
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_61574_22708)"}},[_c('path',{attrs:{"d":"M12.499 6.25a4.5 4.5 0 00-4.276-4.494l-.224-.006a4.5 4.5 0 00-4.5 4.5c0 2.485-.527 4.586-1.055 5.667h3.162a.732.732 0 01.116 0h4.551l.058-.003c.02 0 .038.002.057.003h3.167c-.528-1.081-1.056-3.181-1.056-5.667zm-5.894 7.167a1.582 1.582 0 002.785 0H6.605zM14 6.25c0 2.53.591 4.486.985 5.166l.001.001.078.156c.044.107.074.22.09.335l.011.174-.012.174a1.33 1.33 0 01-1.317 1.161h-2.852a3.08 3.08 0 01-.805 1.428 3.084 3.084 0 01-4.36 0 3.082 3.082 0 01-.807-1.428H2.16a1.335 1.335 0 01-1.325-1.336l.012-.174c.023-.172.08-.339.167-.49l.076-.144c.389-.785.908-2.652.908-5.023a6 6 0 016-6l.298.008a6.001 6.001 0 015.702 5.992z","fill":"#4A4A4A"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_61574_22708"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h16v16H0z"}})])])])
          )
        }
      }
    